import { render, staticRenderFns } from "./VotingDetail.vue?vue&type=template&id=524ceda6&scoped=true"
import script from "./VotingDetail.vue?vue&type=script&lang=ts"
export * from "./VotingDetail.vue?vue&type=script&lang=ts"
import style0 from "./VotingDetail.vue?vue&type=style&index=0&id=524ceda6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ceda6",
  null
  
)

export default component.exports